import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { documentsApi } from '../../../lib/api/documentsApi.connect';
export function foldersQueryKey(parentId) {
    return [
        'editor-folders',
        parentId ?? ''
    ];
}
export function useFolders(parentId) {
    return useQuery({
        queryKey: foldersQueryKey(parentId),
        queryFn: ()=>documentsApi.listFolders(parentId),
        staleTime: 60000
    });
}
export function useFolder(id) {
    return useQuery({
        queryKey: [
            'editor-folder',
            id
        ],
        queryFn: ()=>id ? documentsApi.getFolder(id) : Promise.reject(new Error('no folder id')),
        enabled: !!id,
        staleTime: 60000
    });
}
export function useCreateFolder() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ name, parentId })=>documentsApi.createFolder(name, parentId),
        onSuccess: (f)=>{
            qc.invalidateQueries({
                queryKey: foldersQueryKey(f.parentId)
            });
        }
    });
}
export function useRenameFolder() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, name })=>documentsApi.renameFolder(id, name),
        onSuccess: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    'editor-folders'
                ]
            });
        }
    });
}
export function useDeleteFolder() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id)=>documentsApi.deleteFolder(id),
        onSuccess: ()=>{
            qc.invalidateQueries({
                queryKey: [
                    'editor-folders'
                ]
            });
            qc.invalidateQueries({
                queryKey: [
                    'editor-documents'
                ]
            });
        }
    });
}
